<div class="container-fluid">
  <div class="row">
    <div class="col-11 d-flex bar">
      <div class="tab-container d-flex">

        <div class="tab" [class.active]="viewMode === 'allbooking'" (click)="toggleView('allbooking')">
          All Bookings
          <span *ngIf="viewMode === 'allbooking'" class="tickitnumber">{{ BookingTotalCount }}</span>
        </div>

        <div class="tab" [class.active]="viewMode === 'upcoming'" (click)="toggleView('upcoming')">
          Upcoming
          <span *ngIf="viewMode === 'upcoming'" class="tickitnumber">{{ BookingTotalCount }}</span>
        </div>

        <div class="tab" [class.active]="viewMode === 'complete'" (click)="toggleView('complete')">
          Completed
          <span *ngIf="viewMode === 'complete'" class="tickitnumber">{{ BookingTotalCount }}</span>
        </div>

        <div class="tab" [class.active]="viewMode === 'canceled'" (click)="toggleView('canceled')">
          Canceled
          <span *ngIf="viewMode === 'canceled'" class="tickitnumber">{{ BookingTotalCount }}</span>
        </div>
    <div class="tab" [class.active]="viewMode === 'expired'" (click)="toggleView('expired')">
          Expired
          <span *ngIf="viewMode === 'expired'" class="tickitnumber">{{ BookingTotalCount }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-0">
    <div class="col-11  main-table ">
      <div class="table-bar border-bottom d-flex justify-content-between align-items-center">
        <h5>All bookings</h5>
        <div class=" sticky-top table-controls d-flex align-items-center gap-2">
          <div class="search-wrapper d-flex  rounded    position-relative " id="seachboxfirst">
            <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16" height="16" />
            <input class="input-search" type="text" placeholder="Search by name or email id or location"
              [(ngModel)]="searchAll" (input)="onSearchAllChange(searchAll)" />
            <ul *ngIf="searchAll" class="list-group position-absolute w-100 z-3 "
              style="max-height: 200px; overflow-y: auto; margin-top: 2rem;">
              <li class="list-group-item" *ngFor="let user of allBookings">
                {{ user.touristName }} ({{ user.touristEmail }})
                {{ user.guideName }} ({{ user.tourGuideEmail }})
            
              </li>
              <li *ngIf="allBookings.length === 0" class="list-group-item text-muted text-center">
                No users found
              </li>
            </ul>
          </div>



          <select aria-label="Booking Status" [(ngModel)]="selectedFiltertype" style=" height: 2rem;
             border: 1px solid #dddd;
               min-width: 9rem;
                padding-inline: 6px;
                border-radius: 8px;
               max-width: max-content;" (change)="onStatusChange()">
            <option selected value="">All</option>
            <option value="this-month">This Month</option>
            <option value="last-month">Last Month</option>
            <option value="this-year">This Year </option>
            <option value="last-year">Last Year</option>
          </select>


               <select aria-label="Region Filter" [(ngModel)]="RegionFilter"  style=" height: 2rem;
             border: 1px solid #dddd;
               max-width: 6rem;
                padding-inline: 6px;
                border-radius: 8px;
              " (change)="onRegionChange()">
            <option selected value="">All</option>
            <option class="text-truncate"   style="max-width: 150px; 
               overflow: hidden; 
               text-overflow: ellipsis; 
               white-space: nowrap;" *ngFor="let item of regionsName" [value]="item.regionId">{{item.regionName}}</option>

           
          </select>
        </div>
      </div>



      <div class="scrollable">
        <table class="table align-middle mb-0 border-1px  ">
          <thead class=" custom-head">
            <tr class="trow">
              <th scope="col" style="width: 13%;">Booking ID</th>
              <th scope="col" style="width: 10%;">Location</th>
              <th scope="col" style="width: 23%;">Guide</th>
              <th scope="col" style="width: 23%;">Tourist</th>
              <th scope="col" style="width: 24%;">Trip Dates</th>
              <th scope="col" style="width: 16%;"><span style="margin-left: 1rem;">Status</span></th>
              <th scope="col" style="width: 10%; ">Action</th>
            </tr>
          </thead>
          <tbody class="">

            <tr *ngIf="allBookings?.length === 0">
              <td colspan="7" class="text-center py-3 text-muted">

                <div>No Data available.</div>
              </td>
            </tr>
            <tr *ngFor="let item of allBookings ">

              <td>
                <span class="bookid"> BK-{{item.bookingId}}</span>
              </td>

              <td class="location">
                <span>{{item.tourLocation}}</span>
              </td>

              <td>
                <div class="d-flex align-items-center gap-2 guide">
                  <img [src]="item.tourGuideProfilePhotoUrl || 'assets/userIcon/user.png'" class="rounded-circle"
                    width="40" height="40" />
                  <div>
                    <div class="fw-semibold">{{item.guideName}}</div>
                    <div class="text-muted small email">{{item.tourGuideEmail}}</div>
                  </div>
                </div>
              </td>

              <td>
                <div class="d-flex align-items-center gap-2 guide">
                  <img [src]="item.touristProfilePhotoUrl || 'assets/userIcon/user.png'" class="rounded-circle"
                    width="40" height="40" />
                  <div>
                    <div class="fw-semibold">{{item.touristName}}</div>
                    <div class="text-muted small">{{item.touristEmail}}</div>
                  </div>
                </div>
              </td>

              <td class="dates">
                {{item.tourStartDate | customDatePipe}} - {{item.tourEndDate | customDatePipe}}
                <div class="Tripdates" *ngIf="getRemainingDays(item.tourEndDate) >0 "> ({{ getRemainingDays(item.tourEndDate) }} days remaining)</div>
              </td>
              <td class="status-td">
                <span [ngClass]="getStatusClass(item.bookingStatus)">
                  <img [src]="getStatusIcon(item.bookingStatus)" width="17" height="17" />
                  {{ item.bookingStatus === 'Confirmed' ? 'Upcoming' : item.bookingStatus }}
                </span>
              </td>
              <td class="action-img">
                <img data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" (click)="SetSelectedBooking(item)"
                  aria-controls="offcanvasRight" src="assets/userIcon/Action.svg" width="24" height="24" style="margin-left: 1rem;">
              </td>
            </tr>











          </tbody>
        </table>
      </div>
      <div class="bottomtable">
        <app-pegination [pageAll]="allPage" [totalPages]="totalbookingpage" [pageSize]="pageSize"
          (pageChange)="goToPages($event)" (sizeChange)="onSizeChanges($event)">
        </app-pegination>



      </div>
    </div>





  </div>

</div>
<div class="container-fluid">



  <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
    data-bs-backdrop="static">
<app-booking-canvas [selectedBooking]="selectedBooking" (closeCanvas)="closeBookingOffCanava()"></app-booking-canvas>
  </div>